module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/241ad769cabf379fde4d1bf64aa06a8a.png";